<template>
    <TransferFeeDetail
     :url-c-r-m="urlCRM"
      :url-o-m-s="urlOMS"
      :url-e-r-p="urlERP"
     :student="student"
      @close='cancel'/>
</template>
<script>
import TransferFeeDetail
from '../../../vh-sub-modules/ShareModules/src/components/transfer-fee/TransferFeeDetail.vue';

export default {
  name: 'TransferFee',
  components: { TransferFeeDetail },
  props: {
    student: {
      type: Object,
      default: () => {},
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
    idTransfer: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      urlERP: process.env.VUE_APP_SORT_CLASS,
      urlOMS: process.env.VUE_APP_API_OMS,
      urlCRM: process.env.VUE_APP_API_ERP,
    };
  },
  methods: {
    cancel() {
      this.$emit('closePopup');
    },
  },

};
</script>
<style scoped>
</style>
